import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useFetch, usePromise } from '@rad/hooks';
import { getCommunity } from '../../../../common/network/district';
import useCommunityTheme from '../../../../hooks/useCommunityTheme';
// Wears the organization's colors while its contribution is edited; unmounting restores the host's.
const OrgTheme = (props) => {
    var _a;
    const [communityP] = useFetch(getCommunity(props.subdomain));
    const community = usePromise(communityP);
    useCommunityTheme((_a = community === null || community === void 0 ? void 0 : community.themeSettings) !== null && _a !== void 0 ? _a : null);
    return _jsx(_Fragment, {});
};
export default OrgTheme;
